import { BaseControl } from "../base-control";
export class InputControl extends BaseControl {
    get placeholder() {
        //只读状态下不显示提示文字
        return !this.readonlyFormula ? this.controlOpts.placeholder || '' : '';
    }
}
